import { EyeOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form, Modal, notification, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateLoanAgreementAction } from '../../../redux-store/loan-agreements-store';
import { AgreementStatuses, cancelLoanAgreementMutation } from '../constants';

const { Title, Text, Paragraph } = Typography;

const MarkLoanAgreementCancelledBtn = ({
  loanAgreement,
  setError,
  error,
  queryId,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [showingModal, setShowingModal] = useState(null);
  const [cancelLoanAgreement] = useMutation(cancelLoanAgreementMutation);
  const dispatch = useDispatch();

  const locale = useSelector((store) => store.locale, shallowEqual);

  const handleFinish = useCallback(async () => {
    setError(null);
    setLoading(true);
    try {
      const result = await cancelLoanAgreement({
        variables: {
          loanAgreementId: loanAgreement._id,
          status: AgreementStatuses.PREVIEW.key,
        },
      });
      dispatch(
        updateLoanAgreementAction(
          result.data.cancelLoanAgreement.loanAgreement,
          queryId,
        ),
      );
      notification.success({
        message: 'Saved',
        description: 'Agreement updated successfully',
      });
      setShowingModal(null);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
    setLoading(false);
  }, [
    setError,
    dispatch,
    queryId,
    cancelLoanAgreement,
    loanAgreement,
    onSuccess,
  ]);

  return (
    <>
      <Button
        loading={loading}
        icon={<EyeOutlined />}
        onClick={() => setShowingModal(true)}
      >
        Cancel Agreement
      </Button>

      <Modal
        header={null}
        footer={null}
        visible={showingModal}
        closable={!loading}
        destroyOnClose={true}
        maskClosable={!loading}
        onCancel={() => {
          setShowingModal(false);
        }}
        styles={{ body: { paddingTop: 48 } }}
      >
        <Title level={3} style={{ textAlign: 'center', marginBottom: 32 }}>
          Cancel Loan Agreement
        </Title>
        <Form onFinish={handleFinish} layout="vertical">
          <Form.Item>
            <Paragraph style={{ textAlign: 'center' }}>
              You are about to cancel this version of this loan agreement. All
              signing parties will be notified and you will have to create a new
              loan agreement in order to proceed.
            </Paragraph>
            <Paragraph style={{ textAlign: 'center' }}>
              Would you like to continue?
            </Paragraph>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <div
              style={{
                marginRight: -8,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                onClick={() => setShowingModal(null)}
                htmlType="button"
                disabled={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Go Back
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                loading={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Cancel Agreement
              </Button>
            </div>
          </Form.Item>
        </Form>
        {error && (
          <Text type="danger" style={{ marginTop: 16 }}>
            {error}
          </Text>
        )}
      </Modal>

      <style jsx>{``}</style>
      <style jsx global>{``}</style>
    </>
  );
};

export default MarkLoanAgreementCancelledBtn;
